import React from "react";

const PatientDetails = () => {
  return (
    <div>
      <h4>Patient Details</h4>
      <p>Display patient details and history here.</p>
    </div>
  );
};

export default PatientDetails;
